<div class="comment" *ngIf="comment">
  <div class="comment-image-container">
    <img src="../../../../assets/images/user-icon.png" alt="user" />
  </div>

  <div class="comment-right-part">
    <div class="comment-header d-flex justify-content-between align-items-center">
      <div class="comment-author text-primary fw-bold">
        {{ getUserName() }}
      </div>
      <span class="comment-date badge text-bg-light">
        {{ comment.attributes.publishedAt | date: isToday(comment.attributes.publishedAt) ? 'shortTime' : 'd MMM y' }}
      </span>
    </div>

    <div class="comment-body rounded p-3 mt-2 mb-1">
      <div *ngIf="!isEditing()" class="comment-text">
        {{ comment.attributes.body }}
      </div>
      <div 
        *ngIf="replies && replies.length > 0" 
        class="text-muted small mt-1" 
        style="cursor: pointer;" 
        (click)="toggleReplies()"
      >
        {{ replies.length }} réponse{{ replies.length > 1 ? 's' : '' }}
        <i class="ri-arrow-down-s-line" *ngIf="!showReplies"></i>
        <i class="ri-arrow-up-s-line" *ngIf="showReplies"></i>
      </div>
      <app-comment-form
        *ngIf="isEditing()"
        submitLabel="Mettre à jour"
        [hasCancelButton]="true"
        [initialText]="comment.attributes.body"
        (handleSubmit)="updateComment.emit({ text: $event, commentId: comment.id })"
        (handleCancel)="setActiveComment.emit(null)"
      ></app-comment-form>
    </div>

    <div class="comment-actions mt-2">
      <div *ngIf="canLike" class="comment-action like-button" (click)="toggleLike()">
        <i class="ri-heart-{{ comment.liked ? 'fill' : 'line' }} heart-icon" 
           [ngClass]="{ 'liked': comment.liked }"></i>
        <span *ngIf="comment.attributes.likes > 0" class="like-count">
          {{ comment.attributes.likes }}
        </span>
      </div>      
      <div *ngIf="canReply" class="comment-action" (click)="setActiveComment.emit({ id: comment.id, type: activeCommentType.replying })">
        Répondre
      </div>
      <div *ngIf="canEdit" class="comment-action" (click)="setActiveComment.emit({ id: comment.id, type: activeCommentType.editing })">
        Éditer
      </div>
      <div *ngIf="canDelete" class="comment-action" (click)="deleteComment.emit(comment.id)">
        Supprimer
      </div>
    </div>

    <app-comment-form
      *ngIf="isReplying()"
      submitLabel="Répondre"
      [hasCancelButton]="true"
      (handleSubmit)="handleReplySubmit($event)"
      (handleCancel)="setActiveComment.emit(null)"
    ></app-comment-form>

    <div class="replies ms-4 mt-3" *ngIf="replies && replies.length > 0 && showReplies">
      <app-comment
        *ngFor="let reply of displayedReplies"
        [comment]="reply"
        [activeComment]="activeComment"
        (setActiveComment)="setActiveComment.emit($event)"
        (updateComment)="updateComment.emit($event)"
        (deleteComment)="deleteComment.emit($event)"
        (setLike)="setLike.emit($event)"
        (addComment)="addComment.emit($event)"
        [parentId]="comment.attributes.parentId"
        [replies]="[]"
        [articleId]="articleId"
        [liked]="liked"
        [commentType]="commentType"
      ></app-comment>
      <div *ngIf="!showAllReplies && replies.length > maxRepliesToShow">
        <button class="btn btn-sm btn-outline-primary mt-2" (click)="showMoreReplies()">
          Voir les autres réponses ({{ replies.length - maxRepliesToShow }})
        </button>
      </div>      
    </div>
  </div>
</div>
